import React, { useEffect, useState } from 'react';
import RootRoutes from './routes';
import './index.css';
import './assets/font/font.css';
import './assets/css/common.css';
import SplashScreen from './components/splashscreen/SplashScreen';
import { BridgeProvider } from './bridge/BridgeProvider';

function App() {
  const [splashComplete, setSplashComplete] = useState(() => {
    if (typeof window === 'undefined') return false;
    return !!sessionStorage.getItem('splashShown');
  });

  useEffect(() => {
    document.documentElement.classList.add("font-basic");
  }, []);

  return (
    <React.StrictMode>
      <BridgeProvider>
        {!splashComplete && (
          <SplashScreen onComplete={() => setSplashComplete(true)} />
        )}
        {splashComplete && <RootRoutes />}
      </BridgeProvider>
    </React.StrictMode>
  );
}

export default App;
